/**
 * Tiny hook to re-render when any social store key changes.
 */
import { useEffect, useState } from "react";
import { subscribeSocial } from "@/lib/socialStore";
import { subscribeMone } from "@/lib/monetizationStore";

export const useSocialVersion = () => {
    const [v, setV] = useState(0);
    useEffect(() => subscribeSocial(() => setV((x) => x + 1)), []);
    return v;
};

export const useMoneVersion = () => {
    const [v, setV] = useState(0);
    useEffect(() => subscribeMone(() => setV((x) => x + 1)), []);
    return v;
};

/**
 * Compress + resize images to JPEG data URLs so they can be stored in
 * localStorage without exploding the quota.
 */
export const fileToImageDataUrl = (file, maxEdge = 1200, quality = 0.8) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
            const img = new Image();
            img.onerror = reject;
            img.onload = () => {
                const ratio = Math.min(1, maxEdge / Math.max(img.width, img.height));
                const w = Math.round(img.width * ratio);
                const h = Math.round(img.height * ratio);
                const canvas = document.createElement("canvas");
                canvas.width = w;
                canvas.height = h;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, w, h);
                resolve(canvas.toDataURL("image/jpeg", quality));
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    });

/**
 * "x min/hr ago" helper
 */
export const timeAgo = (ts) => {
    const s = Math.floor((Date.now() - ts) / 1000);
    if (s < 60) return "just now";
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h`;
    const d = Math.floor(h / 24);
    if (d < 7) return `${d}d`;
    const w = Math.floor(d / 7);
    if (w < 4) return `${w}w`;
    return new Date(ts).toLocaleDateString();
};

export const timeOfDay = (ts) =>
    new Date(ts).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
